// roleConfigPage.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import DynamicTable from '../components/DynamicTable';
import RoleConfigModal from '../components/RoleConfigModal';
import TopBar from '../components/TopBar';
import TitleBackButton from '../components/TitleBackButton';

import {
  get_roleconfig,
  update_roleconfig,
  delete_roleconfig,
  add_roleconfig,
} from '../api/api';

const RoleConfigPage = () => {
  const { item_id } = useParams();
  const [page, setPage] = useState(1);
  const [roleConfigs, setRoleConfigs] = useState([]);
  const [roleConfigData, setRoleConfigData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isUpdateModalOpen, setUpdateModalOpen] = useState(false);
  const modalRef = useRef();
  const updateModalRef = useRef();
  const [isModalOpen, setModalOpen] = useState(false);

  const onAdd = ()=>{
    openAndResetModal();
  }


  const updateGrid = async () => {
    try {
      const res = await get_roleconfig();
      console.log(res);
      const data = res?.data?.results || [];
      setRoleConfigs(data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    updateGrid();
  }, []);

  const openAndResetModal = () => {
    setModalOpen(true);
    setTimeout(() => {
      modalRef.current?.reset(); // ensure reset happens *after* modal is mounted
    }, 0);
  };


  const openAndResetUpdateModal = (data) => {
    console.log(data);
    setRoleConfigData(data);
    setUpdateModalOpen(true);
    setTimeout(() => {
      updateModalRef.current?.setup(data);
    }, 0);
  };



  const getColumnDefs = () => [
    {
          field: "scoutastic_name",
          headerName: "Ruolo Scoutastic",
          flex: 1,
    },
    {
          field: "pdf_name",
          headerName: "Sigla PDF",
          flex: 1,
    },
  ];

  const editCallback = async (id) => {
    const res = await get_roleconfig();
    if (res?.data?.results) {
      const match = res.data.results.find((c) => c.id === id);
      if (match) {
        openAndResetUpdateModal(match);
      }
    }
  };

  return (
    <div>
      <TopBar />
      <div className="content">
        <div className="main-content">
          <div className="dynamic-table-topbar-right">
            <TitleBackButton title="Configurazione Ruoli" />

            <div>

              <button className="dynamic-table-add-new" onClick={()=>{onAdd()}}>
                Aggiungi
              </button>

            </div>

          </div>

          <div className="dynamic-table-outer">
            <DynamicTable
              items={roleConfigs}
              getColumnDefs={getColumnDefs}
              showDownloadButtons={false}
              updateGrid={updateGrid}
              deleteFunction={delete_roleconfig}
              editCallback={editCallback}
              preventDelete={false}
            />

            <RoleConfigModal
              ref={modalRef}
              roleConfigs={roleConfigs}
              roleConfigData={roleConfigData}
              isOpen={isModalOpen}
              onClose={() => {
                updateGrid();
                setModalOpen(false);
              }}
            />

            <RoleConfigModal
              roleConfigs={roleConfigs}
              ref={updateModalRef}
              roleConfigData={roleConfigData}
              isOpen={isUpdateModalOpen}
              isUpdate={true}
              onClose={() => {
                updateGrid();
                setUpdateModalOpen(false);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoleConfigPage;
